import React, { createContext } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useState } from 'react';

export const LangSwitchContext = createContext();
export function useLangSwitchContext() {
    return React.useContext(LangSwitchContext);
}

export const AvatarTextKindContext = createContext();
export function useAvatarTextKindContext() {
    return React.useContext(AvatarTextKindContext);
}

export const IsMobileContext = createContext();
export function useIsMobileContext() {
    return React.useContext(IsMobileContext);
}
export const IsDesktopOrLaptopContext = createContext();
export function useIsDesktopOrLaptopContext() {
    return React.useContext(IsDesktopOrLaptopContext);
}
export const LayoutWidthContext = createContext();
export function useLayoutWidthContext() {
    return React.useContext(LayoutWidthContext);
}
//-----------------------------------------------------------
export const MenuContext = createContext();
export function useMenuContext() {
    return React.useContext(MenuContext);
}

export const MenuLevelOneContext = createContext();
export function useMenuLevelOneContext() {
    return React.useContext(MenuLevelOneContext);
}

export const MenuLevelTwoContext = createContext();
export function useMenuLevelTwoContext() {
    return React.useContext(MenuLevelTwoContext);
}

export const MenuLevelThreeContext = createContext();
export function useMenuLevelThreeContext() {
    return React.useContext(MenuLevelThreeContext);
}

//-----------------------------------------------------------
let XBreadcrumbsContext = createContext([]);
export function useBreadcrumbs() {
    let breadcrumbs = useContext(XBreadcrumbsContext);
    return breadcrumbs;
}
export function BreadcrumbsProvider({ children, value }) {
    let breadcrumbs = useContext(XBreadcrumbsContext);
    if(!value){
        return <XBreadcrumbsContext.Provider value={[...breadcrumbs]}>{children}</XBreadcrumbsContext.Provider>;    
    }
    return <XBreadcrumbsContext.Provider value={[...breadcrumbs, value]}>{children}</XBreadcrumbsContext.Provider>;
}
//-----------------------------------------------------------
export const NearestObjectContext = createContext();
export function useNearestObjectContext() {
    return React.useContext(NearestObjectContext);
}
export const HierarchicalContext = createContext();
export function useHierarchicalContext() {
    return React.useContext(HierarchicalContext);
}
//-----------------------------------------------------------
export const AccountContext = createContext();
export function useAccountContext() {
    return React.useContext(AccountContext);
}
export const EventContext = createContext();
export function useEventContext() {
    return React.useContext(EventContext);
}
export const LocaladminContext = createContext();
export function useLocaladminContext() {
    return React.useContext(LocaladminContext);
}
export const SchoolContext = createContext();
export function useSchoolContext() {
    return React.useContext(SchoolContext);
}
export const OrganizerContext = createContext();
export function useOrganizerContext() {
    return React.useContext(OrganizerContext);
}
export const TeacherContext = createContext();
export function useTeacherContext() {
    return React.useContext(TeacherContext);
}


export const TestingContext = createContext();
export function useTestingContext() {
    return React.useContext(TestingContext);
}
export const AutomationContext = createContext();
export function useAutomationContext() {
    return React.useContext(AutomationContext);
}

//-----------------------------------------------------------